import { useState, useEffect, useCallback } from "react";
import { motion } from "framer-motion"; // 1. Import motion
import Carousel from "../components/Carousel";
import About from "./About";
import Packages from "./Packages";
import Questionnaire from "./Questionnaries";
import TrendingProducts from "./TrendingProducts";
import Reviews from "./Reviews";

// Assets
import bg1 from "../assets/bg3.mp4";
import bg2 from "../assets/bg2.jpg";
import bg3 from "../assets/bg1.jpg";
import Thyrocare from "./Thyrocare";
import FaqsPreview from "./FaqsPreview";
import Reproductive from "./Reproductive";
import Disposable from "./Disposable";
import WhyChooseUs from "./WhyChooseUs";

const Home = () => {
  const [showQuiz, setShowQuiz] = useState(false);
  const [isQuizDone, setIsQuizDone] = useState(false);

  const carouselImages = [bg1, bg2, bg3];

  const checkQuizStatus = useCallback((isManualCall = false) => {
    const userData = JSON.parse(localStorage.getItem("user") || "{}");
    const guestResults = sessionStorage.getItem("quiz_results");
    const isLoggedIn = !!userData?.user_id;
    const attempted = Number(userData?.total_questions_attempted || 0);

    const userFullyDone = isLoggedIn && attempted >= 16;
    const guestDone = !isLoggedIn && guestResults !== null;

    if (userFullyDone || guestDone) {
      setIsQuizDone(true);
      if (!isManualCall) setShowQuiz(false);
    } else {
      setIsQuizDone(false);
      if (!isManualCall) setShowQuiz(true);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    checkQuizStatus();
  }, [checkQuizStatus]);

  const handleQuizComplete = () => {
    checkQuizStatus(true);
  };

  // 2. Define the Animation Variant
  const revealVariants = {
    hidden: { opacity: 0, y: 50 }, // Start invisible and 50px down
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { duration: 0.8, ease: "easeOut" } 
    }
  };

  const sectionWrapper = "relative w-full bg-white overflow-hidden";

  return (
    <div className="relative bg-gray-50">
      <Questionnaire
        isOpen={showQuiz}
        onClose={() => setShowQuiz(false)}
        onCompleteSuccess={handleQuizComplete}
      />

      {/* Hero Section - Usually doesn't need reveal animation */}
      <section className="relative w-full overflow-hidden">
        <Carousel images={carouselImages} />
      </section>

      {/* Wrap each section in motion.section */}
      
      <motion.section 
        className={sectionWrapper}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }} // amount 0.2 means trigger when 20% is visible
        variants={revealVariants}
      >
        <About />
      </motion.section>
 <motion.section 
        className={sectionWrapper}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }} // amount 0.2 means trigger when 20% is visible
        variants={revealVariants}
      >
        <WhyChooseUs />
      </motion.section>
      <motion.section 
        className={sectionWrapper}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={revealVariants}
      >
        <Reproductive />
      </motion.section>
  <motion.section 
        className={sectionWrapper}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={revealVariants}
      >
        <div className="py-10 md:py-20">
          <Packages />
        </div>
      </motion.section>
      <motion.section 
        className={sectionWrapper}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={revealVariants}
      >
        <div className="">
          <Disposable />
        </div>
      </motion.section>

      <motion.section 
        className={sectionWrapper}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={revealVariants}
      >
        <div className="">
          <Thyrocare />
        </div>
      </motion.section>

    

      <motion.section 
        className={sectionWrapper}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={revealVariants}
      >
        <div className="py-12 md:py-24">
          <TrendingProducts />
        </div>
      </motion.section>

      <motion.section 
        className={sectionWrapper}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={revealVariants}
      >
        <div className="py-12 md:py-24">
          <FaqsPreview />
        </div>
      </motion.section>

      <motion.section 
        className="relative w-full bg-white"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={revealVariants}
      >
        <Reviews />
      </motion.section>

      {/* Floating Quiz Button */}
      {!isQuizDone && (
        <div className="fixed bottom-6 left-6 md:bottom-8 md:left-8 z-[100] animate-bounce">
          <button
            onClick={() => setShowQuiz(true)}
            className="bg-pink-600 text-white px-5 py-3 md:px-6 md:py-4 rounded-2xl shadow-2xl font-bold text-xs md:text-sm flex items-center gap-2 hover:bg-pink-700 transition-all border-2 border-white"
          >
            ✨ <span>Personalize My Flow</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default Home;